package org.gymly.auth

object SessionActivity {
    private var lastActivityMs: Long = 0L
    private var lastPersistMs: Long = 0L

    fun touch(forcePersist: Boolean = false) {
        val now = currentEpochMs()
        lastActivityMs = now
        if (forcePersist || now - lastPersistMs >= PERSIST_THROTTLE_MS) {
            lastPersistMs = now
            AuthPersistence.saveLastActivityAt(now)
        }
    }

    fun syncFromPersistence() {
        AuthPersistence.loadLastActivityAt()?.let { stored ->
            if (stored > lastActivityMs) lastActivityMs = stored
        }
    }

    fun isIdleExpired(now: Long = currentEpochMs()): Boolean {
        if (lastActivityMs <= 0L) return false
        return now - lastActivityMs >= SessionIdlePolicy.idleTimeoutMs
    }

    fun clear() {
        lastActivityMs = 0L
        lastPersistMs = 0L
        AuthPersistence.clearLastActivityAt()
    }

    fun markSessionStarted() {
        touch(forcePersist = true)
    }
}

private const val PERSIST_THROTTLE_MS = 5_000L
